import { getStepCreator, getUseWizard } from 'features/wizard';
import type { Schedule } from 'types';

export type ScheduleWizardState = {
  schedule: Partial<Schedule>;
};

export const stepCreator = getStepCreator<ScheduleWizardState>();
export const useWizard = getUseWizard<ScheduleWizardState>();
